import { render, staticRenderFns } from "./block-accident-towing.vue?vue&type=template&id=be269150&scoped=true"
import script from "./block-accident-towing.vue?vue&type=script&lang=js"
export * from "./block-accident-towing.vue?vue&type=script&lang=js"
import style0 from "./block-accident-towing.vue?vue&type=style&index=0&id=be269150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be269150",
  null
  
)

export default component.exports